import BulkUpload from "./BulkUpload";
import { Grid } from "@mui/material";
import Header from "../../../components/custom/Header";
import SingleUpload from "./SingleUpload";
import Tabs from "../../../components/custom/Tabs";
import { styled } from "@mui/system";

const StyledContainer = styled(Grid)`
  width: 100%;
  height: 100%;
`;

const Upload = () => {
  return (
    <>
      <StyledContainer sx={{ p: { xs: 2, md: 10 } }}>
        <Header name="Upload Books" />

        <Tabs labels={[{ text: "Single" }, { text: "Bulk" }]}>
          <SingleUpload />
          <BulkUpload />
        </Tabs>
      </StyledContainer>
    </>
  );
};

export default Upload;
